import { Injectable } from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { EasySpinnerService } from '../../controls/easy-spinner/easy-spinner.service';

@Injectable()
export class LoadingScreenInterceptor  implements HttpInterceptor {

    activeRequests = 0;

    skippUrls = [
        '/authrefresh',
        '/api/transformador',
        '/api/red',
        // '/api/cashin-cashout/by-operation-center'
        // '/api/integration'
        // '/o/token'
      ];

    constructor(private spinner: EasySpinnerService) {
    }
  
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        let displayLoadingScreen = true;

        for (const skippUrl of this.skippUrls) {
            if (new RegExp(skippUrl).test(req.url)) {
              displayLoadingScreen = false;
              break;
            }
          }

          if (displayLoadingScreen) {
            if (this.activeRequests === 0) {
              if (new RegExp('/api/menu').test(req.url)) {
                this.spinner.show('menu');
              } else if (new RegExp('/o/token').test(req.url)) {
                this.spinner.show('login');
              } else {
                this.spinner.show('general');
              }
            }

            this.activeRequests ++;

            return next.handle(req).pipe(
              finalize(() => {
                this.activeRequests --;
                if (this.activeRequests === 0) {
                  if (new RegExp('/api/menu').test(req.url)) {
                    this.spinner.hide('menu');
                  } else if (new RegExp('/o/token').test(req.url)) {
                    this.spinner.hide('login');
                  } else {
                    this.spinner.hide('menu');
                    this.spinner.hide('general');
                  }
                }
              })
            );
          } else {
            return next.handle(req);
          }
    }
}